import _ from 'lodash';
import moment from 'moment';
import Uuid from "../../../../support/Uuid";

class ComplementoVehiculoUsadoInputPipe {

  getName() {
    return 'VehiculoUsado';
  }

  apply(data, comprobante) {
    const { Complemento } = data;

    if (!Complemento || !Complemento.VehiculoUsado) {
      return data;
    }

    const { VehiculoUsado } = Complemento;

    let { InformacionAduanera = [] } = VehiculoUsado;

    InformacionAduanera = _.map(InformacionAduanera, (item) => {
      item.id = Uuid.v4();
      item.fecha = moment(item.fecha).toDate();

      return item;
    });

    data.Complemento.VehiculoUsado = {
      ...VehiculoUsado,
      InformacionAduanera : [
        ...InformacionAduanera
      ],
    }

    return data;
  }

}

export default ComplementoVehiculoUsadoInputPipe;